// @flow

import _ from 'lodash/fp';
import React from 'react';
import './ApartmentConfigList.css';

export type Props = {
  list: any[],
  onSelectItem: Function,
};

const ApartmentConfigList = ({list, onSelectItem}: Props) => {
  return (
    <div className="ApartmentConfigList">
      <label>
        Lägenhetskonfigurationer
      </label>
      <div className="list">
        {(!list || !list.length) &&
          <div className="empty-item">
            Inga konfigurationer
          </div>
        }
        {!!(list && list.length) &&
          _.map(d => (
            <div
              key={d.id}
              className="row no-row-margins item">
              <button
                onClick={() => onSelectItem(d)}
                type="button"
                className="button column item-label">
                {d.name}
              </button>
            </div>
          ), list)
        }
      </div>
    </div>
  );
};

export default ApartmentConfigList;



// WEBPACK FOOTER //
// ./src/components/ApartmentConfigList/ApartmentConfigList.js